<template>
	<div class="content-container">
		<!-- 头部 -->
		<div>
			<el-breadcrumb>
				<el-breadcrumb-item>财务管理</el-breadcrumb-item>
				<el-breadcrumb-item>银行卡管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- 头部 end -->

		<!-- 中间内容 -->
		<div class="primary-container">
			<div class="add-mank-card" v-if="!bankInfo">
				<header>
					<img src="https://oss.huarendjk.com/img/2021-12-31/61ceb4a119529.png">
				</header>

				<footer class="footer-btn" @click="handleAddCardClick">
					<div>
						<img src="https://oss.huarendjk.com/img/2021-12-31/61ceb44e778a6.png">
						<span>添加银行卡</span>
					</div>
				</footer>
			</div>

			<section class="mark-card-info" v-else>
				<div class="card-item">
					<header class="card-item-header">
						<span>{{ card_bank.name }}</span>
						<span>储蓄卡</span>
					</header>
					<footer class="card-item-footer">
						<p class="card-item-name">持卡人：{{ bankInfo.card_name }}</p>
						<p class="card-item-name">{{ card_num }}</p>
						<footer class="card-item-footer-btn-group">
							<span @click="handleUpdateClick">修改信息</span>
							<!-- <span @click="handleCancelClick">解绑此卡</span> -->
						</footer>
					</footer>
				</div>
			</section>
		</div>
		<!-- 中间内容 end -->

		<!-- 弹窗 -->
		<el-dialog :title="dialogTitle" width="40%" :visible.sync="dialogVisible">
			<div class="dialog-content-container">
				<el-form :model="form" :rules="rules" ref="form" label-width="auto" style="margin-left: 30px;">
					<el-form-item label="选择银行" prop="card_bank" required>
						<el-select v-model="form.card_bank" placeholder="请选择银行" style="width: 170px;">
							<el-option v-for="(item, index) in bankList" :label="item.name" :value="item.id"
								:key="index"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="开户行姓名" prop="card_name" required>
						<el-input v-model="form.card_name" style="width: 170px;" />
					</el-form-item>
					<el-form-item label="开户行预留手机号" prop="card_phone" required>
						<el-input v-model="form.card_phone" style="width: 170px;" />
					</el-form-item>
					<el-form-item label="银行卡卡号" prop="card_num" required>
						<el-input v-model="form.card_num" style="width: 300px;" />
					</el-form-item>
					<el-form-item label="上传证件" required>
						<div class="upload-id-card">
							<div class="id-card-item">
								<el-upload class="upload-id-card" :headers="headers" action=""
									:http-request="uploadObverse" :show-file-list="false" :multiple="false">
									<img v-if="card_identity_front" :src="card_identity_front">
									<img v-else src="https://oss.huarendjk.com/img/2021-12-31/61cec91bd70f0.png">
								</el-upload>
								<span v-if="!card_identity_front">(上传身份证人像面)</span>
							</div>
							<div class="id-card-item">
								<el-upload class="upload-id-card" :headers="headers" action=""
									:http-request="uploadReverse" :show-file-list="false" :multiple="false">
									<img v-if="card_identity_reverse" :src="card_identity_reverse">
									<img v-else src="https://oss.huarendjk.com/img/2021-12-31/61cec95388c02.png">
								</el-upload>
								<span v-if="!card_identity_front">(上传身份证国徽面)</span>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleCloseClick">取 消</el-button>
				<el-button type="primary" @click="handleSubmitFormClick">提 交</el-button>
			</span>
		</el-dialog>
		<!-- 弹窗 end -->
	</div>
</template>

<script>
	export default {
		name: 'Card',
		data() {
			return {
				// 弹窗显示
				dialogVisible: false,
				// 弹窗标题
				dialogTitle: '',
				// 表单数据
				form: {},
				// 请求头
				headers: {
					'Content-Type': 'multipart/form-data'
				},
				// 证件正面
				card_identity_front: '',
				// 证件反面
				card_identity_reverse: '',
				// 银行名列表
				bankList: [],
				// 代理信息列表
				agentList: [],
				// 银行卡信息
				bankInfo: {},
				// 加密的银行卡号
				card_num: '',
				// 银行
				card_bank: {},
				// 表单校验规则
				rules: {
					card_bank: [{
						required: true,
						message: '请选择银行',
						trigger: 'change'
					}],
					card_num: [{
							required: true,
							message: '请输入银行卡号',
						},
						{
							pattern: /^([1-9]{1})(\d{11}|\d{15}|\d{16}|\d{17}|\d{18})$/,
							message: '请输入正确的银行卡号',
							trigger: 'blur'
						}
					],
					card_phone: [{
							required: true,
							message: '请输入开户行预留手机号',
						},
						{
							pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
							message: '请输入正确的手机号',
							trigger: 'blur'
						}
					],
					card_name: [{
						required: true,
						message: '请输入开户行姓名',
					}]
				}
			}
		},
		//页面加载完成
		created() {
			this.getBankList();
			this.getAgentInfo();
		},
		methods: {
			// 添加银行卡按钮
			handleAddCardClick() {
				this.dialogTitle = '添加银行卡';
				this.dialogVisible = true;
			},
			// 关闭弹窗按钮
			handleCloseClick() {
				this.dialogVisible = false;
				this.resetForm();
			},
			// 打开弹窗按钮
			handleOpenClick() {
				this.dialogVisible = true
			},
			// 提交按钮
			handleSubmitFormClick() {
				this.$refs.form.validate(valid => {
					if (valid) {
						if (!this.card_identity_front) {
							this.$message.error('请上传身份证人像面');
							return;
						}
						if (!this.card_identity_reverse) {
							this.$message.error('请上传身份证国徽面');
							return;
						}
						this.form.card_bank = this.bankList[this.form.card_bank];
						this.form.card_identity_front = this.card_identity_front;
						this.form.card_identity_reverse = this.card_identity_reverse;
						this.addCard();
					}
				})
			},
			// 添加银行卡
			addCard() {
				this.$util.get('/agent/write_agent_info', this.form)
					.then(res => {
						console.log('res', res)
						this.dialogVisible = false;
						this.getAgentInfo()
					})
			},
			// 修改信息按钮
			handleUpdateClick() {
				this.dialogTitle = '修改银行卡信息';
				this.dialogVisible = true;
				this.form = {
					card_bank: this.card_bank.id,
					card_name: this.bankInfo.card_name,
					card_phone: this.bankInfo.card_phone,
					card_num: this.bankInfo.card_num
				}
				this.card_identity_front = this.bankInfo.card_identity_front
				this.card_identity_reverse = this.bankInfo.card_identity_reverse
			},
			// 解绑此卡按钮
			handleCancelClick() {
				this.$confirm('确定解绑该银行卡吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$message({
						type: 'success',
						message: '解绑成功!'
					});
				})
			},
			// 重置表单
			resetForm() {
				this.$refs.form.resetFields();
				this.card_identity_front = '';
				this.card_identity_reverse = '';
			},
			// 获取银行信息
			getBankList() {
				this.$util.get('/agent/bank')
					.then(res => this.bankList = res)
			},
			// 获取代理信息
			getAgentInfo() {
				this.$util.get('/agent/getAgentInfo')
					.then(res => {
						this.agentList = res;
						console.log(res)
						var num, num1, num2
						var nums = ""
						if (this.agentList[0].bank_info) {
							this.bankInfo = JSON.parse(this.agentList[0].bank_info)
							num = this.bankInfo.card_num.substr(-4, 4)
							num1 = this.bankInfo.card_num.substr(0, 4)
							var length = this.bankInfo.card_num.length
							for (let i = 1; i < length; i++) {
								if (i != 0 || i != 1 || i != 2 || i != 3 || i != length - 3 || i != length - 2 || i !=
									length - 1 || i != length) {
									num2 = this.bankInfo.card_num.slice(this.bankInfo.card_num[i], 1)
									num2 = '*'
									nums = nums + num2
								}
							}
							this.card_num = num1 + ' ' + nums + ' ' + num
							if (this.bankInfo.card_bank) {
								this.card_bank = JSON.parse(this.bankInfo.card_bank)
							} else {
								this.card_bank = {}
							}
							console.log(this.bankInfo)
						} else {
							this.bankInfo = {}
							this.card_num = ''
							this.card_bank = {}
						}
					})
			},
			// 上传证件正面
			uploadObverse(file) {
				const formData = new FormData();
				formData.append('file', file.file);
				this.uploadToServer(formData).then(res => this.card_identity_front = res);
			},
			// 上传证件反面
			uploadReverse(file) {
				const formData = new FormData();
				formData.append('file', file.file);
				// 这里或许可以 const serverImg = await this.uploadToServer(formData);
				this.uploadToServer(formData).then(res => this.card_identity_reverse = res);
			},
			// 上传到服务器
			async uploadToServer(data) {
				let serverImg = '';
				await this.$util.upload('/upload', data)
					.then(res => serverImg = res.data.data);
				return serverImg;
			}
		}
	}
</script>

<style lang="less" scoped>
	.content-container {

		.dialog-content-container {

			.upload-id-card {
				height: 101px;
				display: flex;

				.id-card-item {
					margin-right: 30px;
					display: flex;
					flex-direction: column;
					align-items: center;
					width: 160px;
					height: 123px;

					img {
						width: 160px;
						height: 101px;
					}
				}
			}
		}

		.primary-container {
			margin-top: 20px;
			display: flex;

			.add-mank-card {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;
				width: 423px;
				height: 300px;

				.footer-btn {

					div:hover {
						cursor: pointer;
					}

					div {
						border: 1px dashed #4A94EB;
						width: 343px;
						height: 48px;
						text-align: center;
						line-height: 48px;

						img {
							margin-right: 4px;
							width: 12px;
							height: 12px;
						}

						span {
							font-size: 14px;
							font-weight: bold;
							color: #4A94EB;
						}

					}
				}

				header {
					width: 200px;
					height: 220px;

					img {
						width: inherit;
						height: inherit;
					}
				}
			}

			.mark-card-info {
				flex: 1;

				.card-item {
					display: flex;
					flex-direction: column;
					width: 400px;
					height: 220px;
					background: rgba(255, 255, 255, 0.39);
					border: 1px solid #DDDDDD;
					border-radius: 10px;

					.card-item-header {
						box-sizing: border-box;
						display: flex;
						justify-content: space-between;
						padding: 0 30px;
						width: inherit;
						height: 65px;
						background: linear-gradient(266deg, #4A94EB 0%, #5FBDFB 100%);
						border-radius: 10px 10px 0px 0px;
						color: #F6F6F6;
						line-height: 80px;

						span:first-child {
							font-size: 20px;
							font-weight: 400;
						}

						span:last-child {
							font-size: 16px;
							font-weight: 400;
						}
					}

					.card-item-footer {
						flex: 1;
						position: relative;

						.card-item-name {
							margin-left: 30px;
							font-size: 18px;
							font-weight: 400;
							color: #333333;
						}

						.card-item-footer-btn-group {
							position: absolute;
							right: 20px;
							bottom: 20px;
							font-weight: 400;

							span:hover {
								cursor: pointer;
							}

							span:first-child {
								margin-right: 20px;
								font-size: 18px;
								color: #007CFF;
							}

							span:last-child {
								font-size: 18px;
								color: #888888;
							}
						}
					}
				}
			}
		}
	}
</style>
